// extracted by mini-css-extract-plugin
export default {"topBar":"NavBar_topBar__CyZR2","salonName":"NavBar_salonName__jp9bs","menuButton":"NavBar_menuButton__IwvXq"};